import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CapitalContributeInterface, CapitalContributeStateI } from "./domain/capital-contribute-state"
import { addCapitalContributeReq, getCapitalContributeByDateReq, getCapitalContributeByDateAndUserReq } from "../../app/services/capital.service"

const initialState: CapitalContributeStateI = {
  contributeCapitalForm: {
    name: "",
    value: 0,
    userId: "",
  },
  history: [],
  loading: false,
  showModalForm: false,
}

export const addCapitalThunk = createAsyncThunk( "CapitalContribute/AddCapitalReq", async ({value, name, userId} : {value: number, name: string, userId: string}) => {
  const addCapital = await addCapitalContributeReq({ value, name, userId })
  return addCapital
})

export const getCapitalByDateThunk = createAsyncThunk( "CapitalContribute/GetCapitalByDate", async ({date} : {date: string }) => {
  const getCapitals = await getCapitalContributeByDateReq({ date })
  return getCapitals
})

export const getCapitalByDateAndUserThunk = createAsyncThunk( "CapitalContribute/GetCapitalByDateAndUser", async ({date, userId} : {date: string, userId: string }) => {
  const getCapitals = await getCapitalContributeByDateAndUserReq({ date, userId })
  return getCapitals
})

export const CapitalContributeSlice = createSlice({
  name: "CapitalContribute",
  initialState,
  reducers: {
    updateInputContributeCapitalFormAction: (
      state,
      action: PayloadAction<{ key: string; value: string | number }>,
    ) => {
      state.contributeCapitalForm[action.payload.key] = action.payload.value
    },
    showModalContributeCapitalAction: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.showModalForm = action.payload
    },
  },
  extraReducers(builder) {
    builder.addCase(addCapitalThunk.pending, (state) => {state.loading = true})
    builder.addCase(getCapitalByDateThunk.pending, (state) => {state.loading = true})
    builder.addCase(getCapitalByDateAndUserThunk.pending, (state) => {state.loading = true})
    builder.addCase(addCapitalThunk.fulfilled, (state, action: PayloadAction<CapitalContributeInterface>) => {
      state.loading = false
      state.showModalForm = false
      state.history.push(action.payload)
      state.contributeCapitalForm = {
        name: "", value: 0, userId: ""
      }
    })
    builder.addCase(getCapitalByDateThunk.fulfilled, (state, action: PayloadAction<CapitalContributeInterface[]>) => {
      state.loading = false;
      state.history = action.payload
    })
    builder.addCase(getCapitalByDateAndUserThunk.fulfilled, (state, action: PayloadAction<CapitalContributeInterface[]>) => {
      state.loading = false;
      state.history = action.payload
    })
  },
})

export const {
  updateInputContributeCapitalFormAction,
  showModalContributeCapitalAction
} = CapitalContributeSlice.actions

export default CapitalContributeSlice.reducer
